import { useContext } from "react"
import { useOutletContext } from "react-router-dom";

export function BuddyDetailsDetail() {
	const buddy = useOutletContext();
	return (
		<>
			<div id="detail-info-grid">
				<div className="grid">

					<div>
						<p>Buddy Name</p>
						<p>{buddy.buddy_name}</p>
					</div>

					<div>
						<p>Email</p>
						<p>{buddy.email}</p>
					</div>
					<div>
						<p>Phone number</p>
						<p>{buddy.phone_number}</p>
					</div>
					<div>
						<p>Role</p>
						<p>{buddy.role}</p>
					</div>
					<div>
						<p>Permissions</p>
						<p>{buddy.permissions}</p>
					</div>

					<div>
						<p>Date Created</p>
						<p>{buddy.date_created}</p>
					</div>
					<div>
						<p>System ID</p>
						<p>{buddy.buddy_id}</p>
					</div>
				</div>
			</div>


		</>
	)
}